import { Grid } from '@mui/material'
import { AutomaticListAddingComponent, CustomInput } from 'src/consumer/components/helperComponents'

export default function TemplateDoctorInfo({
  doctorInfo,
  handleChangeObject,
  disabled,
  hideDesignation = false,
  hideRegId = false,
  hideCmoRegId = false,
  hideDegrees = false,
  hideAffiliations = false,
  hideDoctorOtherDetails = false,
  hideDoctorName = false,
}) {
  return (
    <>
      {!hideDoctorName && (
        <Grid item xs={12}>
          <CustomInput
            id="doctorName"
            value={doctorInfo?.doctorName}
            label="Doctor Name to show on prescription"
            onChange={handleChangeObject}
          />
        </Grid>
      )}
      {!hideDesignation && (
        <Grid item xs={12}>
          <CustomInput
            id="designation"
            value={doctorInfo?.designation}
            label="Designation"
            onChange={handleChangeObject}
          />
        </Grid>
      )}
      {!hideRegId && (
        <Grid item xs={12}>
          <CustomInput
            id="regId"
            value={doctorInfo?.regId}
            label="Registration ID"
            onChange={handleChangeObject}
          />
        </Grid>
      )}
      {!hideCmoRegId && (
        <Grid item xs={12}>
          <CustomInput
            id="cmoRegId"
            value={doctorInfo?.cmoRegId}
            label="CMO Registration ID"
            onChange={handleChangeObject}
          />
        </Grid>
      )}
      {/* <Grid item xs={12}>
        <CustomCreatableSelect
          isMulti
          id="listOfDegrees"
          label={'Degrees'}
          value={doctorInfo?.listOfDegrees}
          options={listOfDegreesOptions}
          onChangeEvent={handleChangeListOfDegrees}
          onCreateOption={handleCreateDegree}
          getOptionValue={(option) => option?.name}
          getOptionLabel={(option) => option.name}
          // inputvalue={qualificationInput}
          // onInputChange={handleInputChange}
          placeholder="Add degrees and press enter to add them..."
          getNewOptionData={(inputValue, optionLabel) => ({
            id: inputValue,
            name: optionLabel,
          })}
          formatCreateLabel={(value) => `Press enter to add: ${value}`}
          selectType={selectTypes.string}
          noOptionsMessage={() => 'Enter a degree.'}
          styles={{
            option: (provided, state) => {
              if (state.data.__isNew__) {
                return { ...provided, color: '#6b50aa' }
              } else {
                return provided
              }
            },
          }}
          disabled={disabled}
        />
      </Grid> */}
      {!hideDegrees && (
        <Grid item xs={12}>
          <AutomaticListAddingComponent
            id="listOfDegrees"
            label="Degrees"
            value={doctorInfo?.listOfDegrees}
            onChange={handleChangeObject}
          />
        </Grid>
      )}
      {!hideAffiliations && (
        <Grid item xs={12}>
          <AutomaticListAddingComponent
            id="affiliations"
            label="Affiliations"
            value={doctorInfo?.affiliations}
            onChange={handleChangeObject}
          />
        </Grid>
      )}
      {!hideDoctorOtherDetails && (
        <Grid item xs={12}>
          <AutomaticListAddingComponent
            id="doctorOtherDetails"
            label="Other Details"
            value={doctorInfo?.doctorOtherDetails}
            onChange={handleChangeObject}
          />
        </Grid>
      )}
    </>
  )
}
